<template lang="pug">
  //- #pills-transaction.tab-pane.fade(role="tabpanel" aria-labelledby="pills-transaction-tab" :class="{'active show' : tabTarget === 'transaction'}")
  #pills-transaction.tab-pane.fade.active.show(role="tabpanel" aria-labelledby="pills-transaction-tab")
    .d-lg-none
      .d-flex.history-single(v-for="ticket in transactionHistory")
        .flex-grow-1
          .history-type {{ticket.request_type}}
          .history-method {{ticket.deposit_method}} ({{ticket.target_bank_id}})
          .text-secondary.history-date {{$moment(ticket.created_date).format("YYYY-MM-DD HH:mm:ss")}}
        .history-right
          .history-amount.text-right {{ticket.currency_code}} {{$numeral(ticket.amount).format("0,0.00")}}
          .text-right.text-secondary.history-status(:class="getColor(ticket.status, ticket.request_type)") {{getStatus(ticket.status, ticket.request_type)}}
    .d-none.d-lg-block
      .package-table.mb-0
        .row.table-row
          .col No.
          .col-2 Date
          .col Type
          .col Method
          .col Bank
          .col Amount
          .col Status
          .col-2 ETA
        .row.table-row(v-for="(ticket, index) in transactionHistory")
          .col {{index+1}}
          .col-2(v-if="ticket.created_date") {{$moment(ticket.created_date).format("YYYY-MM-DD HH:mm:ss")}}
          .col-2(v-else) -
          .col {{ticket.request_type}}
          .col(v-if="ticket.deposit_method != null ") {{ticket.deposit_method}}
          .col(v-else) -
          .col {{ticket.target_bank_id}}
          .col {{$numeral(ticket.amount).format("0,0.00")}}
          .col(:class="getColor(ticket.status, ticket.request_type)") {{getStatus(ticket.status, ticket.request_type)}}
          .col-2 {{$moment(ticket.created_date).add(5, "m").format("YYYY-MM-DD HH:mm:ss")}}
</template>

<script>
import config from "@/config"
import errorTags from "@/errorTags"
export default {
  props:{
    tabTarget: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      lastUpdateTime: new Date(),
      transactionHistory: [],
      refreshTicket: null
    };
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    appID() {
      return config.app_id
    }
  },
  mounted(){
    var vm = this
    this.getMemberTicketList();
    this.refreshTicket = setInterval(() => {
      vm.getMemberTicketList()
    }, 10000)
  },
  beforeDestroy: function() {
    clearInterval(this.refreshTicket)
  },
  methods: {
    getStatus(status, request) {
      var tag = "ui.unknown";
      switch(status) {
        case -1:
          tag = "ui.failed";
          break;
        case 0:
          if(request === "WITHDRAWAL"){
            tag = "ui.approved";
          }else{
            tag = "ui.pending";
          }
          break;
        case 1:
          tag = "ui.approved";
          break;
      }
      return this.$t(tag);
    },
    getColor(status, request) {
      var tag = "";
      switch(status) {
        case -1:
          tag = "text-danger";
          break;
        case 0:
          if(request === "WITHDRAWAL"){
            tag = "text-success"
          }else{
            tag = "text-warning";
          }
          break;
        case 1:
          tag = "text-success";
          break;
      }
      return tag;
    },
    getMemberTicketList() {
      if (this.sessionToken) {
        this.lastUpdateTime = new Date()
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let app_id = this.appID
        this.$store
          .dispatch("user/getMemberTicketList", { account_id, auth_token, app_id })
          .then(response => {
            if (response.success == true) {
              this.transactionHistory = response.data;
            } else {
              if((typeof response.status) != 'object' && response.status != 0 && response.status != '0'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object' && response.status != 0 && response.status != '0'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            } 
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
          });
      }
    }
  }
};
</script>
